import { render, staticRenderFns } from "./org-detail.vue?vue&type=template&id=681b94bf&scoped=true"
import script from "./org-detail.vue?vue&type=script&lang=js"
export * from "./org-detail.vue?vue&type=script&lang=js"
import style0 from "./org-detail.vue?vue&type=style&index=0&id=681b94bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b94bf",
  null
  
)

export default component.exports